module.exports = __webpack_public_path__ + "img/cy.db13343f.svg";